"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PermissionController = require("./PermissionController");
var _useBroadcastParams = require("../../hooks/useBroadcastParams");
var getEventId = function getEventId(user, eventId) {
  // Hack to enable storybook tests to run
  user.testEventId && (eventId = user.testEventId);
  return eventId;
};
var getEvent = function getEvent(user, eventId) {
  return user.events.filter(function (evt) {
    return evt.event === eventId;
  })[0];
};
var verifyUserPermissions = function verifyUserPermissions(currentEvent, viewPermissions, permissions) {
  var canAccessFeature = (0, _PermissionController.verifyRolePermissionsOnFeature)(currentEvent, viewPermissions);
  return permissions.every(function (perm) {
    return canAccessFeature(perm) === true;
  });
};
var Permissions = function Permissions(_ref) {
  var protectedComponent = _ref.protectedComponent,
    _ref$permissions = _ref.permissions,
    permissions = _ref$permissions === void 0 ? [] : _ref$permissions,
    user = _ref.user,
    viewPermissions = _ref.viewPermissions;
  var eventId = (0, _useBroadcastParams.useBroadcastParams)();
  // verify against provided permission context
  var optEventId = (0, _PermissionController.maybe)(getEventId)(user, eventId || {});
  var currentEvent = (0, _PermissionController.maybe)(getEvent)(user, optEventId);
  var hasAccess = verifyUserPermissions(currentEvent, viewPermissions, permissions);
  return protectedComponent(hasAccess);
};
Permissions.propTypes = {
  permissions: _propTypes["default"].array.isRequired,
  protectedComponent: _propTypes["default"].func.isRequired,
  viewPermissions: _propTypes["default"].object.isRequired,
  user: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Permissions);